import { h } from 'preact';

export default (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" role="img" {...props}>
			<path fill-rule="evenodd" clip-rule="evenodd" d="M32 0C14.327 0 0 14.327 0 32C0 49.673 14.327 64 32 64C49.673 64 64 49.673 64 32C64 14.327 49.673 0 32 0ZM16.3021 11.7766C20.6371 8.40691 26.0845 6.40013 32 6.40013C46.1382 6.40013 57.6 17.8619 57.6 32.0001C57.6 37.9159 55.5933 43.3633 52.2237 47.698L16.3021 11.7766ZM11.7766 16.3021C8.40685 20.6371 6.40006 26.0845 6.40006 32.0001C6.40006 46.1383 17.8618 57.6001 32.0001 57.6001C37.9158 57.6001 43.3633 55.5933 47.698 52.2238L11.7766 16.3021Z" />
		</svg>
	);
};